import { DotLottie } from "@lottiefiles/dotlottie-web";

export default {
    name: 'lottie',
    component() {
        return {
            init() {
                const dotLottie = new DotLottie({
                    autoplay: true,
                    loop: false,
                    canvas: this.$el.querySelector("#lottie-test"),
                    id: "firstLottie",
                    speed: 1.25,
                    src: "/CAT_01.lottie",
                    layout: {
                        fit: "fill",
                        align: [0, 0],
                    },
                });
            },
        }
    }
} 